import { COLOR_ARR } from "@/pages/dashboard/_config/constant";

export const LIGHT_COLOR_ARR =  COLOR_ARR;
export const DARK_COLOR_ARR =  COLOR_ARR;
export const EXTENSION_STYLE = 'position: absolute;z-index: 99999;color: #fff;font-size: 12px;padding: 5px;display: inline;border-radius: 4px;background-color: #303133;box-shadow: rgba(0, 0, 0, 0.3) 2px 2px 8px';
export const CHART_FONT_FAMILY = "Roboto Regular,-apple-system,PingFang SC,microsoft yahei ui,microsoft yahei,sans-serif";